<template>

<v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
   <template v-slot:activator="{ on }">
    <v-btn v-if="$store.state.cordova" dark color="primary" v-on="on" @click="doScanCordova()">
        <v-icon v-text="buttonIcon" class="mr-2"></v-icon>
        Scan
    </v-btn>
    <v-btn v-if="!$store.state.cordova" dark color="primary" v-on="on" @click="doScanPWA()">
        <v-icon v-text="buttonIcon" class="mr-2"></v-icon>
        Scan
    </v-btn>
    <img v-if="image != null" ref="image" :src="image" width="200px" height="auto" @load="imageLoaded"/>
    <img v-if="imageScaled != null" :src="imageScaled" width="auto" height="auto" class="hidden"/>
    <input type="file" ref="pictureCamera" accept="image/*" capture="camera" class="hidden" @change="onSelectImage">
  </template>
  <v-card>

    <v-toolbar dark color="primary">
      <v-btn icon dark @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-items>
        <v-btn dark text @click="dialog = false">Save</v-btn>
      </v-toolbar-items> -->
    </v-toolbar>

    <v-container fluid fill-height>
      <v-row dense>
        <v-col>

          <v-text-field v-model="barcode" label="Barcode"></v-text-field>
          <h4 v-text="message"></h4>

          <v-btn v-if="$store.state.cordova"  dark color="primary" @click="doScanCordova()">
            <v-icon v-text="buttonIcon" class="mr-2"></v-icon>
            Scan
          </v-btn>
          <v-btn v-if="!$store.state.cordova" dark color="primary"  @click="doScanPWA()">
            <v-icon v-text="buttonIcon" class="mr-2"></v-icon>
            Scan
          </v-btn>

          <v-form ref="form" v-model="valid" class="mx-5 px-5">
            <v-text-field clearable v-model="searchInput" :rules="searchRules">
              <template v-slot:label>
                Search
              </template>
            </v-text-field>
          </v-form>

        </v-col>
      </v-row>
       <v-row dense v-if="notFoundName">
        <v-col>
           <v-form class="mx-5 px-5">
            <h4 v-text="message"></h4>
            <v-btn color="green" dark large @click="onAddNewBeerClick()" class="mx-2">
                Yes
            </v-btn>
            <v-btn color="error" large @click="dialog = false" class="mx-2">
                No
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
     <v-row dense>
        <v-col>
       <v-container fluid fill-height>
            <template v-for="beer in beers">
               <Beer v-bind="beer" :key="beer.beerId" collectionType="none" @open="onBeerClick(arguments[0])"/>
            </template>
          </v-container>
        </v-col>
      </v-row>
      <v-footer absolute>
        <div v-show="busy == false" ref="Bottom"><h4>...</h4></div>
      </v-footer>
    </v-container>
  </v-card>

   <v-overlay :value="busy">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</v-dialog>

</template>

<script>
import Beer from '@/components/Beer.vue';

const observerOptions = {
  root: null,
  threshold: 0,
};

export default {
  name: 'BeerSearchBarcode',
  components: {
    Beer,
  },
  props: {
    buttonIcon: {
      type: String,
      default: 'mdi-barcode-scan',
    },
    title: {
      type: String,
      default: 'Scan',
    },
    collectionId: Number,
  },
  data: () => ({
    dialog: false,
    beers: [],
    searchInput: '',
    searchRules: [
      (v) => (v && v.length >= 3) || (!v) || 'Minimum 3 chars',
    ],
    valid: true,
    busy: true,
    page: 0,
    pages: 0,
    barcode: '',
    message: '',
    notFound: false,
    debounce: null,
    notFoundName: false,
    image: null,
    imageScaled: null,
    imagefile: null,
  }),
  beforeMount() {
  },
  methods: {
    doScanCordova() {
      cordova.plugins.barcodeScanner.scan((scanResult) => {
        this.barcode = scanResult.text;
        if (this.barcode) {
          const data = {
            barcode: this.barcode,
          };

          this.$webConn.request('app2_get_beer_by_barcode', data).then((result) => {
            if (result.result) {
              this.dialog = false;
              this.$emit('open', result.beerId);
            } else {
              this.message = 'Whoops we didn\'t find that barcode, can you please tell us which beer it is?';
              this.notFound = true;
            }
          }).catch((error) => {
            alert(error.Message);
          });
        }
      }, (error) => {
        console.log(error);
      },
      {
        preferFrontCamera: false, // iOS and Android
        showFlipCameraButton: true, // iOS and Android
        showTorchButton: true, // iOS and Android
        torchOn: false, // Android, launch with the torch switched on (if available)
        saveHistory: false, // Android, save scan history (default false)
        prompt: 'Place a barcode inside the scan area', // Android
        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        // formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
        // orientation: "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
        disableAnimations: true, // iOS
        disableSuccessBeep: false, // iOS and Android
      });
    },
    doScanPWA() {
      this.busy = true;
      // trigger file input
      this.$refs.pictureCamera.click();
    },
    onSelectImage(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.imagefile = files[0];
      const reader = new FileReader();
      reader.readAsDataURL(this.imagefile);
      reader.onload = (f) => {
        this.image = f.target.result;
      };
    },
    uploadImage() {
      const data = {
        image: this.imageScaled,
      };

      this.$webConn.request('app2_get_beer_by_barcode', data).then((result) => {
        this.busy = false;
        this.barcode = result.barcode;
        if (result.barcode === 0) {
          this.message = 'Scan failed';
        } else if (result.result) {
          this.dialog = false;
          this.$emit('open', result.beerId);
        } else {
          this.message = 'Whoops we didn\'t find that barcode, can you please tell us which beer it is?';
          this.notFound = true;
        }
      }).catch((error) => {
        alert(error.Message);
      });
    },
    imageLoaded(e) {
      const img = e.target;
      const width = 700;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // -- canvas scaling --
      const start = window.performance.now();

      canvas.width = width;
      canvas.height = canvas.width * (img.height / img.width);
      ctx.filter = 'contrast(1.5) brightness(1.5) grayscale(100%)';
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      let data = canvas.toDataURL('image/webp', 0.5); // webp seems to compress very good
      if (data.substring(0, 15) !== 'data:image/webp') { // webp not supported fallback to jpg
        data = canvas.toDataURL('image/jpeg', 0.8);
      }
      this.imageScaled = data;
      this.uploadImage();
    },
    onBeerClick(beerId) {
      this.dialog = false;
      this.searchInput = '';
      this.$emit('open', beerId);
      this.beers = [];

      const data = {
        barcode: this.barcode,
        beerId,
      };

      this.$webConn.request('app2_link_barcode', data).then((result) => {
        this.barcode = 0;
      }).catch((error) => {
        alert(error.Message);
      });
    },
    onAddNewBeerClick() {
      this.$router.push({ name: 'BeerAdd', params: { collectionId: this.collectionId, newName: this.searchInput, newBarcode: this.barcode } });
    },
  },
  mounted() {
  },
  computed: {
  },
  watch: {
    searchInput(val, oldVal) {
      if (this.dialog) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          if (this.valid) {
            this.page = 0;
            const data = {
              search: val,
            };

            this.busy = true;

            this.$webConn.request('app2_get_beers', data).then((result) => {
              this.pages = result.pages;
              this.beers = result.Beers;
              this.busy = false;
              if (!result.Beers.length) {
                this.notFound = false;
                this.notFoundName = true;
                this.message = 'Sorry, we don\'t seem to know that one yet, do you want to add it?';
              } else {
                this.notFound = false;
                this.notFoundName = false;
                this.message = '';
              }
            }).catch((error) => {
              alert(error.Message);
            });
          }
        }, 500);
      }
    },
  },
};
</script>
